import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

const linkSpacing = 12;

export const Wrapper = styled.nav`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-left: auto;
`;

export const Divider = styled.div`
	margin: 0 ${linkSpacing}px;
	background-color: ${colors.grey3};
	width: 1px;
	height: 24px;
`;
